import React, { useState } from "react";
import { Navbar, Nav, Container, Button, NavDropdown } from 'react-bootstrap';
import { Link, useLocation } from "react-router-dom";

export default function NavbarComponent() {
  const location = useLocation();
  const [showCoursesDropdown, setShowCoursesDropdown] = useState(false);
  const [showCareersDropdown, setShowCareersDropdown] = useState(false);
  const [showIndustryDropdown, setShowIndustryDropdown] = useState(false)
  return (
    <>
      <Navbar bg="light" expand="lg" className="shadow-sm darkmode">
        <Container fluid>
          {/* Left side: Logo */}
          <Navbar.Brand href="/">
            <img
              src="images/Digisoftlogo.png"
              alt="Logo"
              className="brand-logo"
              style={{ height: '80px',width:'100%' }}
            />
          </Navbar.Brand>

          {/* Center: Navigation links */}
          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav">
            <div className="w-100 d-flex flex-column align-items-center">
              {/* Hiring Notice */}
              {/* <div className="text-muted hirings" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>
                Now Hiring: Are you a driven and motivated 1st Line IT Support Engineer?
              </div>

              {/* Horizontal Line */}
              {/* <hr style={{ width: '70%', borderColor: '#ddd', margin: '8px 0' }} /> */} 

              {/* Navigation Links */}
              <Nav className="mx-auto navitems-link" style={{ gap: '70px' }}>
                <Nav.Link as={Link} className={`nav-item-spacing ${location.pathname === '/' ? 'active' : ''}`}
                  to='/'>Home</Nav.Link>
                <Nav.Link as={Link} className={`nav-item-spacing ${location.pathname === '/aboutus' ? 'active' : ''}`}
                  to='/aboutus'>About us</Nav.Link>
                <NavDropdown title='Services'
                  id="service-dropdown"
                  className={`nav-item-spacing navigators ${location.pathname.includes('/service') ? 'active' : ''}`}
                  onMouseEnter={() => setShowCoursesDropdown(true)}
                  onMouseLeave={() => setShowCoursesDropdown(false)}
                  show={showCoursesDropdown}
                >
                  <NavDropdown.Item as={Link} to="/it-strategy-consulting" className="nav-item-listing">
                  IT Strategy and Consulting</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/it-staffing-resource" className="nav-item-listing">
                 IT Staffing and Resource Augmentation</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/digital-transformation" className="nav-item-listing">
                  Digital Transformation</NavDropdown.Item>
                </NavDropdown>

                <NavDropdown title='Industries'
                  id="industry-dropdown"
                  className={`nav-item-spacing navigators ${location.pathname.includes('/service') ? 'active' : ''}`}
                  onMouseEnter={() => setShowIndustryDropdown(true)}
                  onMouseLeave={() => setShowIndustryDropdown(false)}
                  show={showIndustryDropdown}
                >
                  <NavDropdown.Item as={Link}
                   to="/industries/asset-management" 
                   className="nav-item-listing">
                  Asset Management</NavDropdown.Item>
                  <NavDropdown.Item as={Link}
                   to="/industries/banking" 
                   className="nav-item-listing">
                 Banking</NavDropdown.Item>
                  <NavDropdown.Item as={Link}
                   to="/industries/capitalmarkets" 
                   className="nav-item-listing">
                  Capital Markets</NavDropdown.Item>
                  <NavDropdown.Item as={Link}
                   to="/industries/healthcare" 
                   className="nav-item-listing">
                  Healthcare</NavDropdown.Item>
                  <NavDropdown.Item as={Link}
                   to="/industries/manufacturing" 
                   className="nav-item-listing">
                  Manufacturing</NavDropdown.Item>
                  <NavDropdown.Item as={Link} 
                  to="/industries/transportation" 
                  className="nav-item-listing">
                  Transportation</NavDropdown.Item>
                  <NavDropdown.Item as={Link} 
                  to="/industries/facilities-management" 
                  className="nav-item-listing">
                  Facilities Management</NavDropdown.Item>
                </NavDropdown>
                
                {/* <Nav.Link as={Link} to='/services'>Services</Nav.Link> */}
                <NavDropdown title='Careers'
                id="career-dropdown"
                className={`nav-item-spacing navigators ${location.pathname.includes('/careers') ? 'active' : ''}`}
                  onMouseEnter={() => setShowCareersDropdown(true)}
                  onMouseLeave={() => setShowCareersDropdown(false)}
                  show={showCareersDropdown}
                >
                  <NavDropdown.Item as={Link} to="/vacancies" className="nav-item-listing">
                  Vacancies</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/cv" className="nav-item-listing">
                 Submit your CV</NavDropdown.Item>
                 </NavDropdown>
                 {/* <Nav.Link as={Link} className={`nav-item-spacing ${location.pathname === '/careers' ? 'active' : ''}`}
                 to='/careers'>Careers</Nav.Link> */}
                 <Nav.Link as={Link} className={`nav-item-spacing ${location.pathname === '/contactus' ? 'active' : ''}`}
                 to='/contactus'>Contact Us</Nav.Link>
              </Nav>
              
              
            </div>
          </Navbar.Collapse>
          {/* Right side: Hiring notice, phone number, and icons */}
          <div className="d-flex align-items-center chat-contact">
            <a
             href="https://wa.me/97451852341?text=Hello,%20I%20have%20a%20question%20about%20your%20services"
             target="_blank"
             rel="noopener noreferrer"
             className="d-flex align-items-center text-decoration-none text-muted"
             >
            <img src="images/chat.svg" alt="chat-bubbles" width={'14%'} />
            <div className="me-3 text-muted questions" style={{ fontSize: '18px', paddingLeft: '20px' }}>


              Have any questions?<br /> Chat : +974 51852341

            </div>
</a>
            {/* <Button variant="link" className="text-muted p-0 me-2">
          <i className="fas fa-comment"></i> {/* Chat icon */}

            {/* </Button>
          <Button variant="link" className="text-muted p-0">
          <i className="fas fa-search"></i> {/* Search icon */}
            {/* </Button> */}

          </div>
        </Container>
      </Navbar>
    </>
  )
}